<!-- 谷峰平预警界面 -->
<template>
  <div class="survey-manage-box">
    <div class="left-box">
      <div style="height: 100%;display: flex;flex-direction: column">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText" style="margin-bottom: 20px" clearable>
        </el-input>
        <el-tree style="overflow: auto;flex: 1;height: 0;" :data="treeData" :props="defaultProps" default-expand-all
          :filter-node-method="filterNode" ref="tree" node-key="thirdDeviceId" show-checkbox>
        </el-tree>
      </div>
    </div>
    <div class="right-box access-record-container">
      <!--主页面 -->
      <div class="flex-row" style="height: 100%">
        <div class="flex-auto flex-valign" style="overflow: hidden">
          <!-- 右侧表格 -->
          <div class="section-main_table" style="flex-direction: column">
            <!-- 查询条件 -->
            <div class="query">
              <el-form style="margin-top: 10px; transition: all 200ms" :class="showSearch ? 'expand searchContent' : 'up searchContent'
                " :inline="true" ref="search-form" label-position="right" :model="searchForm">
                <el-form-item label="起始日期">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm.startTime"
                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="截止日期">
                  <el-date-picker type="date" value-format="yyyy-MM-dd" placeholder="选择日期" v-model="searchForm.endTime"
                    :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
              </el-form>

              <div style="display: flex;flex-direction: row;justify-content: space-between;">
                <el-button type="primary" @click="searchResult">{{
                  $t("accountGroup.button.query")
                }}
                </el-button>
                <el-button type="primary" @click="handleExportOpt">导出</el-button>
                <el-button type="info" @click="resetQuery">{{
                  $t("accountGroup.button.reset")
                }}
                </el-button>
                <el-button type="text" size="medium" v-show="showExpandBtn" style="color: #407aee"
                  @click="showSearch = !showSearch" :icon="showSearch ? 'el-icon-arrow-up ' : 'el-icon-arrow-down'
                      ">{{ !showSearch ? "展开" : "收起" }}
                </el-button>
              </div>
            </div>
            <ioc-table ref="accessTab" :data="tableData" :option="tableOption" :page="page" @row-cancle="closeDialog"
              @current-change="selectPage" @size-change="changeSize">
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="查看图表" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" icon="el-icon-s-data" @click="handleChartOpt(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- 图表展示弹窗 -->
    <el-dialog title="查看图表" :append-to-body="true" :visible.sync="dialogChart" width="54%" class="choose-container">
      <div class="dialog-content-box">
        <div class="dialog-content-item" style="margin: 0px 20px; flex: 1">
          <h3 style="margin: 10px 10px 0px 10px">峰平谷用电趋势</h3>
          <div class="gfp-trend-box">
            <div class="gfp-trend-title-box" style="justify-content: flex-end">
              <div style="display: inline-flex; align-items: center">
                <span style="width: 80px">回路名称</span>
                <h3>{{ deviceName }}</h3>
              </div>
              <div style="margin-left: 10px">
                <span> 日期 </span>
                <el-date-picker v-model="selectDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                  @change="handleTimeChange" :picker-options="pickerOptions" :clearable="selectDateClear">
                </el-date-picker>
              </div>
            </div>
            <!-- <div class="gfp-trend-title-box">
              <div>kW·h</div>
              <div>峰平谷</div>
            </div> -->
            <div class="line-legend">
              <div class="legend-label-first"></div>
              <div class="legend-text">峰</div>
              <!-- <div class="legend-label-second"></div> -->
              <div class="legend-label-third"></div>
              <div class="legend-text">平</div>
              <!-- <div class="legend-label-third"></div> -->
              <div class="legend-label-second"></div>
              <div class="legend-text">谷</div>
            </div>
            <div id="gfpChart" style="width: 100%; height: 17rem"></div>
          </div>
        </div>
      </div>
      <!--      <span slot="footer" class="dialog-footer">-->
      <!--        <el-button type="info" @click="cancelChartChoose">取消</el-button>-->
      <!--        <el-button type="primary" @click="confirmChartChoose">确认</el-button>-->
      <!--      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import eCharts from "echarts";
import { api } from "../api/index";
import { Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/guFengPingTable";

export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      defaultProps: {
        children: "children",
        label: "thirdDeviceName",
      },
      filterText: "",
      deviceName: "",
      deviceId: "",
      treeData: [],
      tableOption: tableOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],

      searchForm: {
        startTime: "",
        endTime: "",
      },
      showExpandBtn: false,
      showSearch: false,
      // 查看图表
      dialogChart: false,
      hlName: "",
      selectDate: "",
      gfpChart: null,
      gfpChartOpt: null,
      trendAnalysis: {},
      selectDateClear: false
    };
  },
  mounted() {
    this.searchForm.startTime = this.getDay(-1)
    this.searchForm.endTime = this.getDay(-1)
    // this.initChartData();
    // window.onresize = () => {
    //   this.bwRateChart.resize();
    // };
    this.getTableList();
    this.getTreeData();
    this.animation();
  },
  beforeDestroy() {
    // window.onresize = null;
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    // 导出操作
    handleExportOpt() {
      const params = {
        ...this.searchForm,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ids: this.$refs.tree.getCheckedKeys()
      };
      this.$fetchDownLoad(api.gfpWarning.exportVpfDataOfDay, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "谷峰平预警" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    animation() {
      let that = this;
      let domAry =
        document.querySelector(".searchContent") &&
        document.querySelector(".searchContent").children;
      // console.log("--谷峰平--domAry:-", domAry);
      if (!domAry) {
        return;
      }
      window.onresize = function () {
        that.animation();
      };
      if (domAry[domAry.length - 1].offsetTop != domAry[0].offsetTop) {
        // console.log("--00--");
        this.showExpandBtn = true;
      } else {
        // console.log("--111--");
        this.showExpandBtn = false;
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.thirdDeviceName.indexOf(value) !== -1;
    },
    // 获取树数据
    getTreeData() {
      this.$fetch(api.meterIndicator.queryEnergyMeterTree).then(res => {
        if (res.success) {
          this.treeData = res.returnObj[0].children
        }
      })
    },
    // 获取右侧表格列表
    getTableList() {
      const params = {
        startTime: this.searchForm.startTime ? this.searchForm.startTime : '',
        endTime: this.searchForm.endTime ? this.searchForm.endTime : '',
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
        ids: this.$refs.tree.getCheckedKeys()
      };
      this.$fetch(api.gfpWarning.getEnergyMeterData, params).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.data])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        }
      );
    },
    closeDialog() {
    },

    // 查询按钮事件
    searchResult() {
      // console.log("---查询--this.searchForm:--", this.searchForm);
      this.page.currentPage = 1;
      this.getTableList();
    },
    // 重置按钮
    resetQuery() {
      // this.searchForm.startTime = "";
      // this.searchForm.endTime = "";
      this.searchForm.startTime = this.getDay(-1)
      this.searchForm.endTime = this.getDay(-1)
      this.$refs.tree.setCheckedKeys([])
      // console.log("---重置--this.searchForm:--", this.searchForm);
      this.getTableList();
    },
    cancelChartChoose() {
      this.dialogChart = false;
    },
    confirmChartChoose() {
      this.cancelChartChoose();
    },
    // 查看图表操作
    handleChartOpt(obj) {
      // console.log("--查看图表操作--");
      this.dialogChart = true;
      this.deviceName = obj.deviceName
      // this.deviceId = obj.id
      this.deviceId = obj.deviceId
      this.selectDate = this.searchForm.startTime
      this.$fetch(api.meterIndicator.trendAnalysisOfVfp + '?id=' + obj.deviceId + '&dateStr=' + this.searchForm.startTime).then(res => {
        if (res.success) {
          this.trendAnalysis = res.returnObj
          this.initGfpTrendChart();
        }
      })
    },
    handleTimeChange(val) {
      const date = val ? val : ''
      this.$fetch(api.meterIndicator.trendAnalysisOfVfp + '?id=' + this.deviceId + '&dateStr=' + date).then(res => {
        if (res.success) {
          this.trendAnalysis = res.returnObj
          this.initGfpTrendChart();
        }
      })
    },
    initGfpTrendChart() {
      let chartDom = document.getElementById("gfpChart");
      this.gfpChart = eCharts.init(chartDom);
      // this.gfpChartOpt = {
      //   color: ["#2FC5F1", "#D24280", "#C0BDD7"],
      //   grid: {
      //     left: "3%",
      //     right: "4%",
      //     bottom: "3%",
      //     containLabel: true,
      //   },
      //   xAxis: [
      //     {
      //       type: "category",
      //       boundaryGap: false,
      //       axisLine: {
      //         lineStyle: {
      //           color: "#000",
      //           width: 1,
      //           type: "solid",
      //         },
      //       },
      //       axisLabel: {
      //         textStyle: {
      //           color: "#000",
      //         },
      //       },
      //       axisTick: {
      //         show: false,
      //       },
      //       data: this.trendAnalysis.chartData.map(v => v.startTime),
      //     },
      //   ],
      //   yAxis: [
      //     {
      //       type: "value",
      //       axisLine: {
      //         lineStyle: {
      //           color: "#000",
      //           width: 1,
      //           type: "solid",
      //         },
      //       },
      //       axisLabel: {
      //         textStyle: {
      //           color: "#000",
      //         },
      //       },
      //       axisTick: {
      //         show: false,
      //       },
      //     },
      //   ],
      //   series: [
      //     {
      //       name: "",
      //       type: "line",
      //       stack: "Total",
      //       smooth: true,
      //       lineStyle: {
      //         width: 0,
      //       },
      //       showSymbol: false,
      //       itemStyle: {
      //         normal: {
      //           label: {
      //             show: true,
      //             position: "top",
      //             textStyle: {
      //               color: "#000",
      //               fontSize: 12,
      //             },
      //           },
      //         },
      //       },
      //       areaStyle: {
      //         opacity: 0.8,
      //         color: new eCharts.graphic.LinearGradient(0, 0, 0, 1, [
      //           {
      //             offset: 0,
      //             color: "rgb(128, 255, 165)",
      //           },
      //           {
      //             offset: 1,
      //             color: "rgb(1, 191, 236)",
      //           },
      //         ]),
      //       },
      //       emphasis: {
      //         focus: "series",
      //       },
      //       data: this.trendAnalysis.chartData.map(v => v.value),
      //     },
      //   ],
      // };
      // const lineColor = ['rgba(130, 107, 244, 0.7)', 'rgba(18, 206, 108, 0.7)', 'rgba(242, 75, 75, 0.7)']
      const lineColor = ['rgba(18, 206, 108, 0.7)', 'rgba(130, 107, 244, 0.7)', 'rgba(242, 75, 75, 0.7)']
      const arrLength = this.trendAnalysis.chartData.length
      const pieces = this.trendAnalysis.chartData.map((v, index) => {
        return {
          lte: index == arrLength - 1 ? null : index + 1,
          gt: index == 0 ? null : index,
          color: lineColor[v.type],
        }
      })
      this.gfpChartOpt = {
        title: {
          subtext: '(kw/h)',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '5%',
          // top:'0',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // X轴底部文字颜色
          axisLabel: {
            interval: 0,//横轴信息全部显示
            rotate: -20,// -20度角倾斜显示
          }, // X轴底部文字倾斜，用于文字过多，有些字不展示的处理
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // X轴网格线的颜色和solid
          data: this.trendAnalysis.chartData.map(v => v.dataTime),
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          axisPointer: {
            snap: true
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(104,105,123)'
            }
          }, // Y轴底部文字颜色
          splitLine: {
            lineStyle: {
              color: "rgba(104,105,123)",
              type: "dashed"
            }
          }, // Y轴网格线的颜色和solid
        },
        visualMap: {
          show: false,
          dimension: 0,
          pieces: pieces
        },
        series: [
          {
            areaStyle: {},
            name: "用电量",
            type: 'line',
            smooth: true,
            data: this.trendAnalysis.chartData.map(v => v.value),
          }
        ]
      }
      this.gfpChart.setOption(this.gfpChartOpt);
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getTableList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getTableList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.expand {
  width: calc(100% - 410px);
  height: auto;
}

.up {
  width: calc(100% - 410px);
  height: 41px;
  overflow: hidden;
}

.survey-manage-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;

  .left-box {
    width: 0px;
    flex: 1;
    height: 100%;
    padding: 20px;
    margin-right: 15px;
    @include set_theme_color(background-color, left-menu-bg-color);

    .title-box {
      margin-top: 10px;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #fff;
      border-left-width: 3px;
      border-left-style: solid;
      padding-left: 10px;
      border-left-color: #407aee;
      position: relative;
    }

    .content-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 10px;

      .content-item {
        width: 85%;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #202631;
      }

      :active {
        background: #202631;
      }

      .content-selected-item {
        background: #202631;
      }

      .content-border-item {
        width: 85%;
        height: 41px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid white;
        padding-left: 20px;
        cursor: pointer;
      }

      :hover {
        background: #202631;
      }

      :active {
        background: #202631;
      }

      .content-selected-item {
        background: #202631;
      }
    }
  }

  .access-record-container {
    width: 100%;
    height: 100%;

    .el-table__fixed-right-patch {
      display: none;
    }

    .el-dialog {

      .el-date-editor.el-input,
      .el-date-editor.el-input__inner {
        width: 260px;
      }
    }
  }

  .right-box {
    width: 0px;
    flex: 5;
    height: 100%;

    .query {
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include set_theme_color(background-color, left-menu-bg-color);
      padding: 10px 16px 3px;

      .el-form-item {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 8px !important;
        vertical-align: top;
      }
    }
  }
}
</style>

<style scoped>
.dialog-content-box {
  height: 40vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.dialog-content-item {
  width: 0px;
  height: 100%;
  flex: 1;
  border-radius: 20px;
  /* border: 1px solid #797979; */
}

.gfp-trend-box {
  height: 31vh;
  width: 100%;
  padding: 0rem 0.5rem;
}

.gfp-trend-title-box {
  width: 100%;
  height: 2rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.line-legend {
  display: flex;
  align-items: center;
  margin: 20px 0;
  justify-content: flex-end;

  .legend-label-first {
    width: 30px;
    height: 15px;
    background-color: rgba(242, 75, 75, 0.7);
    margin-left: 20px;
  }

  .legend-label-second {
    width: 30px;
    height: 15px;
    background-color: rgba(18, 206, 108, 0.7);
    margin-left: 20px;
  }

  .legend-label-third {
    width: 30px;
    height: 15px;
    background-color: rgba(130, 107, 244, 0.7);
    margin-left: 20px;
  }

  .legend-text {
    margin-left: 10px;
  }
}
</style>
